import { render, staticRenderFns } from "./Guideline.vue?vue&type=template&id=60869e7a&"
import script from "./Guideline.vue?vue&type=script&lang=js&"
export * from "./Guideline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports